import React from 'react'
import classnames from 'classnames'

const RenderFields = ({
  input,
  label,
  type,
  meta: { touched, error, warning }
}) => (
  <div className="form-group">    
    <input {...input} type={type} className={classnames('form-control')} />
    <label>{label}</label>
    <div className="error">
     {touched &&
        ((error && <span>{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  </div>
)
export default RenderFields


// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/Contact/components/RenderFields.js